import { Image } from '@chakra-ui/image';
import { Trans } from '@lingui/react';
import React, { useState } from 'react';

import userProfileMenuIcon from '../../../../../../assets/icons/icon_user_profile_menu.svg';
import userProfileMenuIconActive from '../../../../../../assets/icons/icon_user_profiler_menu_active.svg';
import { NotificationType } from '../../../notifications';
import { useSelectorUserProfile } from '../../user-profile.selectors';
import {
    MenuButtonWrapper,
    NotificationsCount,
    ProfileImage,
    ProfileTitle,
    getMenuButtonActiveStyles
} from './user-menu-button.styled';

type MenuButtonProps = {
    notifications: NotificationType[]
    showNotificationCount: boolean
    isOpen: boolean
};

export const UserMenuButton = ({
    notifications,
    showNotificationCount,
    isOpen
}: MenuButtonProps) => {
    const [isHovered, setIsHovered] = useState(false);
    const profileImage = useSelectorUserProfile()?.profileImage;

    return (
        <MenuButtonWrapper
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
            {...getMenuButtonActiveStyles(isOpen)}
        >
            <Image src={isHovered || isOpen ? userProfileMenuIconActive: userProfileMenuIcon} />
            {profileImage ?
                <ProfileImage src={profileImage} /> :
                <ProfileTitle color={'primary.700'}>
                    <Trans id={'userProfile.menu'} />
                </ProfileTitle>
            }
            {showNotificationCount && <NotificationsCount>{notifications.length}</NotificationsCount>}
        </MenuButtonWrapper>
    );
};
